import React, { useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from 'src/components/app-context';
import type { AdvizedExpert, AdvizedCategory } from 'src/types';
import { H3Text } from '@prisjakt/ui/text/variants';
import { ExpertUserCard } from 'src/areas/expert/components/expert-user-card';
import { ExpertUserCardSize } from 'src/areas/expert/types';

import * as S from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  className?: string;
  imageUrl?: string | null;
  pathName: string;
  preamble?: string;
  title: string;
  linkText?: string;
  expert?: AdvizedExpert;
  category?: AdvizedCategory;
};

export const FeaturedCategoryArticle = ({
  className,
  imageUrl,
  pathName,
  preamble,
  title,
  linkText,
  expert,
  category,
}: Props) => {
  const { t } = useContext(AppContext);

  const trackOnClick = useCallback(() => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.FEATURED_CATEGORY_ARTICLE,
      nextPage: pathName,
    });
  }, [pathName]);

  return (
    <S.FeaturedCategoryArticle className={className}>
      <H3Text>
        {category && category!.url && (
          <S.ToplistLink href={category!.url} onClick={trackOnClick}>
            Topplista:{' '}
          </S.ToplistLink>
        )}
        <Link to={pathName} onClick={trackOnClick}>
          {title}
        </Link>
      </H3Text>
      {imageUrl && (
        <S.ImageWrapper>
          <Link to={pathName} onClick={trackOnClick}>
            <img src={imageUrl} alt={title} />
          </Link>
        </S.ImageWrapper>
      )}
      <S.TextContainer>
        {preamble && (
          <Link to={pathName} onClick={trackOnClick}>
            <p>{preamble}</p>
          </Link>
        )}

        {linkText ? (
          <S.ArticleLink
            container={Link}
            containerProps={{ to: pathName, onClick: trackOnClick }}
          >
            {linkText}
          </S.ArticleLink>
        ) : (
          []
        )}
      </S.TextContainer>
      {expert && category!.name && (
        <ExpertUserCard
          experts={[expert]}
          size={ExpertUserCardSize.MEDIUM}
          subtitle={`${t(
            'expert',
            'toplist.expert-within'
          )} ${category!.name.toLowerCase()}`}
        />
      )}
    </S.FeaturedCategoryArticle>
  );
};
